//extracted by mini-css-extract-plugin
export default {"icon":"GenericLocationCard_icon__0vTQU","disabledTag":"GenericLocationCard_disabledTag__CoGcc"};;